import { ApiService } from "@core/services/api.service";
import { ApiServiceHolder } from "@core/utils/api-service-holder";
import { TranslateLoader } from "@ngx-translate/core";
import { ILanguage } from "@shared/interfaces/language.interface";
import { Observable } from "rxjs";

export class TranslationLoaderService implements TranslateLoader {
  AppLanguageList: Array<ILanguage> = [];

  constructor(private _api: ApiService) {

  }


  getTranslation(lang: string): Observable<any> {

    return this._api.request<Observable<any>>(ApiServiceHolder.getTranslations(lang));
  }

  fillLanguages() {
    this._api.request<Array<ILanguage>>(ApiServiceHolder.translation.getAllLanguages()).subscribe((dataR) => {
      this.AppLanguageList = dataR;
    });
  }
}
